import * as React from 'react' ;
import PropTypes from 'prop-types';
import PaneComponent from './pane-component';

export default class PaneContainer extends React.Component {

	render() {
		return <PaneComponent {...this.props} />;
	}

}

PaneContainer.propTypes = {
	active: PropTypes.bool,
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/tabs/pane/pane-container.js